import React from 'react';

function Camera(props: object) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.33847 14.8528H12.1854C13.9886 14.8528 14.7073 13.7487 14.7922 12.4028L15.1319 7.00627C15.2234 5.59507 14.0997 4.39947 12.6819 4.39947C12.2834 4.39947 11.9175 4.1708 11.7346 3.818L11.2642 2.87067C10.9637 2.27613 10.1797 1.78613 9.51327 1.78613H8.01713C7.3442 1.78613 6.5602 2.27613 6.25967 2.87067L5.78927 3.818C5.60633 4.1708 5.24047 4.39947 4.84193 4.39947C3.4242 4.39947 2.30047 5.59507 2.39193 7.00627L2.73167 12.4028C2.81007 13.7487 3.53527 14.8528 5.33847 14.8528Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.78125 5.70605H9.74125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.76005 12.2389C9.92952 12.2389 10.8834 11.285 10.8834 10.1155C10.8834 8.94605 9.92952 7.99219 8.76005 7.99219C7.59059 7.99219 6.63672 8.94605 6.63672 10.1155C6.63672 11.285 7.59059 12.2389 8.76005 12.2389Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Camera;
